import { DefaultValues, useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import {
  DedicatedLanesBidFormSchema,
  TDedicatedLanesBidFormSchema,
} from '../schema/DedicatedLanesBidFormSchema'

export const getDefaultValues = <TDedicatedLanesBidFormSchema>(
  values: DefaultValues<TDedicatedLanesBidFormSchema>
) => {
  return DedicatedLanesBidFormSchema.cast({
    mcNumber: null,
    dotNumber: null,
    rateAmount: undefined,
    rateType: undefined,
    weeklyLoadVolume: undefined,
    contactMessage: undefined,
    canDoWeekends: false,
    estimatedStartDate: undefined,
    truckCount: undefined,
    driverCount: undefined,
    trailerCount: undefined,
    contactPhone: '',
    contactEmail: '',
    ...values,
  })
}

interface IDedicatedLanesBidFormProps
  extends Omit<UseFormOptions<TDedicatedLanesBidFormSchema>, 'resolver'> {}

export const useDedicatedLanesBidForm = ({
  defaultValues,
  ...props
}: IDedicatedLanesBidFormProps = {}) => {
  return useForm({
    resolver: yupResolver(DedicatedLanesBidFormSchema),
    defaultValues: getDefaultValues(defaultValues),
    ...props,
  })
}
